import {
    SxProps,
    Theme,
    Typography,
    TypographyProps,
    TypographyPropsVariantOverrides
} from '@mui/material';
import { TypographyVariant } from '@mui/material/styles';
import { OverridableStringUnion } from '@mui/types';
import { Property } from 'csstype';
import { ReactNode } from 'react';

interface HeadingProps extends TypographyProps {
    label: string | ReactNode;
    sx?: SxProps<Theme>;
    variant?: OverridableStringUnion<
        TypographyVariant | 'inherit',
        TypographyPropsVariantOverrides
    >;
    fontSize?: Property.FontSize | undefined | number;
}

const Heading = ({
    label,
    sx,
    variant: _variant,
    fontSize,
    ...props
}: HeadingProps) => {
    return (
        <Typography
            // Rendered as a div, not Typography's default <p>: `label` is typed
            // as ReactNode and callers pass Stack/Box/Chip trees into it (see
            // ReconciliationTable's CardHeader), which is invalid HTML inside a
            // paragraph and makes React log a nesting error.
            component="div"
            sx={sx}
            style={{
                fontSize: fontSize ? fontSize : '14px',
                lineHeight: '38px',
                fontWeight: 600,
                // letterSpacing: '0.5px',
                textAlign: 'left',
                fontFamily: 'Inter'
            }}
            {...props}
        >
            {label as any}
        </Typography>
    );
};

export default Heading;
